// extracted by mini-css-extract-plugin
export default {"cardBox":"page_cardBox__rIdee","editIcon":"page_editIcon__BK4CQ","contractList":"page_contractList__kl1k9","contentBody":"page_contentBody__SokeP"};